import { computed, unref } from 'vue';
import { useFunctionGetter } from 'dashboard/composables/store';
import { useOperatingProceduresStore } from 'dashboard/stores/operatingProcedures';

// Resolves the SOPs applicable to a conversation: matched by contact reason
// (any of the SOP's reasons tagged on the conversation), market and inbox (a
// blank SOP market or empty inbox list applies to all). A SOP without contact
// reasons never matches on its own; it only runs when another SOP references it.
export function useMatchedSop(currentChat) {
  const operatingProceduresStore = useOperatingProceduresStore();

  const inbox = useFunctionGetter(
    'inboxes/getInbox',
    computed(() => unref(currentChat)?.inbox_id)
  );

  const matchedSops = computed(() => {
    const reasonIds = unref(currentChat)?.contact_reason_ids || [];
    if (!reasonIds.length) return [];
    const market = inbox.value?.market;
    return operatingProceduresStore.getRecords
      .filter(
        sop =>
          sop.contact_reason_ids?.some(id => reasonIds.includes(id)) &&
          (!sop.market || sop.market === market) &&
          (!sop.inbox_ids?.length ||
            sop.inbox_ids.includes(unref(currentChat)?.inbox_id))
      )
      .sort((a, b) => a.name.localeCompare(b.name));
  });

  return { matchedSops };
}
